const RELOAD_KEY = 'ce-deploy-reload';

// Reload at most once per reason, so a bad deploy can't cause a reload loop
function reloadOnce(reason) {
  try {
    if (sessionStorage.getItem(RELOAD_KEY) === reason) {
      return;
    }
    sessionStorage.setItem(RELOAD_KEY, reason);
  } catch (e) {
    return; // no storage means no loop protection, so don't reload
  }
  window.location.reload();
}

async function checkBuild() {
  try {
    const res = await fetch(`${__webpack_public_path__}build.json`, { cache: 'no-cache' });
    if (!res.ok) {
      return;
    }
    const { id } = await res.json();
    if (id && id !== __BUILD_ID__) {
      reloadOnce(`build:${id}`);
    }
  } catch (e) {} // eslint-disable-line no-empty
}

export default function deployGuard() {
  // A chunk a newer deploy removed (stale cached HTML, or an old open tab)
  window.addEventListener('unhandledrejection', e => {
    if (e.reason?.name === 'ChunkLoadError') {
      reloadOnce(`chunk:${__BUILD_ID__}`);
    }
  });

  // HTML from the browser's cache loaded an old app.js
  checkBuild();
}
